import { TFunction } from 'i18next';
import { Nomenclature } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type ActionsMenuArgs = {
  onViewHandler: (v?: Nomenclature) => void;
  onEditHandler: (v?: Nomenclature) => void;
  onDelete: (v?: Nomenclature) => void;
  t: TFunction<'translation', undefined>;
  isViewOnly: boolean;
};

export default function getTableActionsMenu({
  onViewHandler,
  onEditHandler,
  onDelete,
  t,
  isViewOnly,
}: ActionsMenuArgs): NavItem<Nomenclature>[] {
  return [
    {
      id: 'view-action',
      title: t('view'),
      onClick: (item?: Nomenclature) => onViewHandler(item),
      leftIcon: Icons.view,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'edit-action',
      title: t('edit-quantity'),
      onClick: (item?: Nomenclature) => onEditHandler(item),
      leftIcon: Icons.edit,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: (item?: Nomenclature) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
    },
  ];
}
